import {createRouter, createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },

  {
    path: '/artists',
    name: 'artists',
    component: () => import(/* webpackChunkName: "artists" */ '../views/Artists.vue')
  },

  {
    path: '/artist/:slug',
    name: 'artist',
    component: () => import(/* webpackChunkName: "artist" */ '../views/Artist.vue')
  },

  {
    path: '/latest',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },

  {
    path: '/latest/:slug',
    name: 'new',
    component: () => import(/* webpackChunkName: "new" */ '../views/New.vue')
  },

  {
    path: '/features',
    name: 'features',
    component: () => import(/* webpackChunkName: "features" */ '../views/Features.vue')
  },

  {
    path: '/feature/:slug',
    name: 'feature',
    component: () => import(/* webpackChunkName: "feature" */ '../views/Feature.vue')
  },
  
  {
    path: '/library',
    name: 'librarys',
    component: () => import(/* webpackChunkName: "librarys" */ '../views/Librarys.vue')
  },
  
  {
    path: '/library/:slug',
    name: 'library',
    component: () => import(/* webpackChunkName: "library" */ '../views/Library.vue')
  },

  {
    path: '/contributors',
    name: 'contributors',
    component: () => import(/* webpackChunkName: "contributors" */ '../views/Contributors.vue')
  },


  {
    path: '/author/:slug',
    name: 'author',
    component: () => import(/* webpackChunkName: "author" */ '../views/Author.vue')
  },


  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },

  {
    path: '/medium/:slug',
    name: 'directory',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },

  {
    path: '/subject/:slug',
    name: 'subject',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },

  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
  
  {
    path: '/:slug',
    name: 'page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },
  
  {
    path: '/preview-page',
    name: 'preview-page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },

  {
    path: '/preview-home',
    name: 'preview-home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },


  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
]

let base_url = '/';
if (process.env.NODE_ENV === 'production') base_url = '/';
if (process.env.VUE_APP_BUILD_TYPE === 'twelve' && process.env.NODE_ENV === 'production') {
  base_url = '/';
}

const router = createRouter({
  history: createWebHistory(base_url),
  routes
});

export default router;
